/*
 * @Date: 2022-08-23 10:32:40
 * @LastEditors: kinfai
 * @Description: 高度背景墙
 * @LastEditTime: 2022-08-29 09:47:09
 * @FilePath: \my-app\src\components\BgHeader\index.jsx
 */
import AliIcon from "../AliIcon/index.jsx";
import "./index.less";
import useChatPlugin from "@/hooks/chatPlugin/index.js";
import {getPluginConfig} from "../../hooks/chatPlugin";
import {Avatar} from 'antd';


function BgHeader(props) {
    const {getPluginConfig} = useChatPlugin()
    const pageConfig = getPluginConfig()
    const goPage = () => {
        console.log("切换");
    };

    const IsSlot = () => {
        if (props.subComponent === false) {
            return (
                <div className="g-header-inner" onClick={goPage}>
                    <div className="u-logo-box">
                        {
                            pageConfig.brand_icon ?
                                <Avatar src={pageConfig.brand_icon}></Avatar> :
                                <AliIcon type="icon-needkelogocaisetubiao" size="28px"></AliIcon>
                        }
                        {/*<AliIcon type="icon-needkelogocaisetubiao" size="28px"></AliIcon>*/}
                        {/*<Avatar src={pageConfig.brand_icon}></Avatar>*/}
                    </div>
                    <span className="s-title">{pageConfig.brand || 'Needke'}</span>
                </div>
            );
        }

        if (typeof props.subComponent === 'object') {
            return props.subComponent
        } else {
            return props.subComponent()
        }
    };

    return (
        <div
            className="g-header"
            style={{
                height: props.height,
                backgroundColor: pageConfig.bgColor || "#4654a3"
            }}
        >
            {/* {IsSlot()} */}
            <IsSlot/>
        </div>
    );
}

BgHeader.defaultProps = {
    height: "118px",
    subComponent: false,
};

export default BgHeader;
